import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUrunSatisAnaliz_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUrunSatisAnaliz_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  Boss_VItemSalesHeader1: any[];
  Boss_VItemSalesHeader1_dummy: any[];
  Boss_VItemSalesGrid: any[];
  Boss_VItemSalesGrid_dummy: any[];
  ListUser: any[];
  ListUser_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  Boss_VItemSalesHeaderPerson: any[];
  Boss_VItemSalesHeaderPerson_dummy: any[];
  Boss_VItemSalesHeaderProcess: any[];
  Boss_VItemSalesHeaderProcess_dummy: any[];
  Boss_VItemSalesHeaderWarehouse: any[];
  Boss_VItemSalesHeaderWarehouse_dummy: any[];
  Boss_VItemSalesHeaderCollection: any[];
  Boss_VItemSalesHeaderCollection_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp640703Visible: "visible" | "hidden";
  isComp306482Visible: "visible" | "hidden";
  isComp502087Visible: "visible" | "hidden";
  isComp290500Visible: "visible" | "hidden";
  isComp580364Visible: "visible" | "hidden";
  isComp908413Visible: "visible" | "hidden";
  isComp387932Visible: "visible" | "hidden";
  isComp765016Visible: "visible" | "hidden";
  isComp689993Visible: "visible" | "hidden";
  isComp686767Visible: "visible" | "hidden";
  isComp481532Visible: "visible" | "hidden";
  isComp354578Visible: "visible" | "hidden";
}

export class UrunSatisAnaliz_ScreenBase extends React.PureComponent<
  IUrunSatisAnaliz_ScreenProps,
  any
> {
  urunsatisanaliz_999120_value_kuikaSelectBoxRef: React.RefObject<any>;
  urunsatisanaliz_525060_value_kuikaSelectBoxRef: React.RefObject<any>;
  urunsatisanaliz_38920_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "6e32dd29-fb13-454b-9205-bececdc4a055",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 878700, PropertyName: "label", Value: "Profil" },
        { Id: 461758, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 342102, PropertyName: "value", Value: "Ürün Satış Analizi" },
        { Id: 999120, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 554173, PropertyName: "value", Value: "Toplam Satış Miktarı" },
        { Id: 263376, PropertyName: "value", Value: "adet" },
        { Id: 653069, PropertyName: "value", Value: "metrekare" },
        { Id: 131904, PropertyName: "value", Value: "Müşteri Bazında" },
        { Id: 859996, PropertyName: "value", Value: "Operasyonel Bazlı Satış" },
        { Id: 622157, PropertyName: "value", Value: "Mağaza/Depo Bazında" },
        { Id: 311977, PropertyName: "value", Value: "Toplam Satış Tutar" },
        { Id: 403097, PropertyName: "value", Value: "₺" },
        { Id: 224057, PropertyName: "value", Value: "Koleksiyon Bazlı" },
        { Id: 904302, PropertyName: "value", Value: "Top 20 Ürün" },
        {
          Id: 525060,
          PropertyName: "placeholder",
          Value: "Ürün adet/Tutar bazlı arama...",
        },
        { Id: 636739, PropertyName: "placeholder", Value: "Ürün ara..." },
        { Id: 178454, PropertyName: "label", Value: "Ara" },
        { Id: 530330, PropertyName: "label", Value: "Temizle" },
        {
          Id: 38920,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 97762, PropertyName: "title", Value: "Title" },
        { Id: 657610, PropertyName: "value", Value: "Ürün adı" },
        {
          Id: 733260,
          PropertyName: "value",
          Value: "[datafield:itemdescription]",
        },
        { Id: 3684, PropertyName: "value", Value: "Adet" },
        { Id: 937904, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 746267, PropertyName: "value", Value: "Mr2" },
        { Id: 417635, PropertyName: "value", Value: "[datafield:qty2]" },
        { Id: 981268, PropertyName: "value", Value: "Tutar" },
        { Id: 2826, PropertyName: "value", Value: "[datafield:loc_netamount]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.urunsatisanaliz_999120_value_kuikaSelectBoxRef = React.createRef();
    this.urunsatisanaliz_525060_value_kuikaSelectBoxRef = React.createRef();
    this.urunsatisanaliz_636739_value_kuikaTextInputRef = React.createRef();
    this.urunsatisanaliz_38920_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      Boss_VItemSalesHeader1: [],
      Boss_VItemSalesGrid: [],
      ListUser: [],
      GetImage: [],
      Boss_VItemSalesHeaderPerson: [],
      Boss_VItemSalesHeaderProcess: [],
      Boss_VItemSalesHeaderWarehouse: [],
      Boss_VItemSalesHeaderCollection: [],
      ChangeVisibilityOf: "",
      SetValueOf: "",
      dataSource_999120: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son  6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      dataSource_525060: [
        { key: "0", text: "Tutar Bazında" },
        { key: "1", text: "Adet Bazında" },
        { key: "2", text: "Metrekare Bazında" },
      ],
      isComp640703Visible: "hidden",
      isComp306482Visible: "visible",
      isComp502087Visible: "hidden",
      isComp290500Visible: "hidden",
      isComp580364Visible: "visible",
      isComp908413Visible: "hidden",
      isComp387932Visible: "hidden",
      isComp765016Visible: "visible",
      isComp689993Visible: "hidden",
      isComp686767Visible: "hidden",
      isComp481532Visible: "visible",
      isComp354578Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("urunsatisanaliz", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.UrunSatisAnalizPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("urunsatisanaliz", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("urunsatisanaliz", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.UrunSatisAnalizPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  UrunSatisAnalizPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      DateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      ParamByAmount_1: ReactSystemFunctions.convertToTypeByName(0, "number"),
      ItemDescription_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      kUserId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.ListUser !== undefined
            ? stateVars.ListUser?.length > 0
              ? stateVars.ListUser[0].id
              : null
            : this.state.ListUser?.length > 0
            ? this.state.ListUser[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesHeader1 = result?.data.boss_VItemSalesHeader1;
    formVars.urunsatisanaliz_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty1
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty1
        : null
    );
    formVars.urunsatisanaliz_890807_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty2
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty2
        : null
    );
    formVars.urunsatisanaliz_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].loc_NetAmount
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].loc_NetAmount
        : null
    );
    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    stateVars.ListUser = result?.data.listUser;
    stateVars.GetImage = result?.data.getImage;
    formVars.urunsatisanaliz_491941_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UrunSatisAnalizPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.urunsatisanaliz_491941_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.urunsatisanaliz_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty1
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty1
        : null
    );

    formVars.urunsatisanaliz_890807_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty2
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty2
        : null
    );

    formVars.urunsatisanaliz_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].loc_NetAmount
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_891895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UrunSatisAnaliz",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "526188",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_878700_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UrunSatisAnaliz",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_461758_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_999120_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      DateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      DateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      DateFilter_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      DateFilter_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ParamByAmount_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_525060_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ItemDescription_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_636739_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_999120_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesHeader1 = result?.data.boss_VItemSalesHeader1;
    formVars.urunsatisanaliz_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty1
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty1
        : null
    );
    formVars.urunsatisanaliz_890807_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty2
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty2
        : null
    );
    formVars.urunsatisanaliz_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].loc_NetAmount
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].loc_NetAmount
        : null
    );
    stateVars.Boss_VItemSalesHeaderPerson =
      result?.data.boss_VItemSalesHeaderPerson;

    stateVars.Boss_VItemSalesHeaderProcess =
      result?.data.boss_VItemSalesHeaderProcess;

    stateVars.Boss_VItemSalesHeaderWarehouse =
      result?.data.boss_VItemSalesHeaderWarehouse;

    stateVars.Boss_VItemSalesHeaderCollection =
      result?.data.boss_VItemSalesHeaderCollection;

    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_999120_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_999120_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.urunsatisanaliz_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty1
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty1
        : null
    );

    formVars.urunsatisanaliz_890807_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].qty2
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].qty2
        : null
    );

    stateVars.dataSource_605562 =
      stateVars.Boss_VItemSalesHeaderPerson ??
      this.state.Boss_VItemSalesHeaderPerson;

    stateVars.dataSource_922724 =
      stateVars.Boss_VItemSalesHeaderProcess ??
      this.state.Boss_VItemSalesHeaderProcess;

    stateVars.dataSource_977001 =
      stateVars.Boss_VItemSalesHeaderWarehouse ??
      this.state.Boss_VItemSalesHeaderWarehouse;
    formVars.urunsatisanaliz_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VItemSalesHeader1 !== undefined
        ? stateVars.Boss_VItemSalesHeader1?.length > 0
          ? stateVars.Boss_VItemSalesHeader1[0].loc_NetAmount
          : null
        : this.state.Boss_VItemSalesHeader1?.length > 0
        ? this.state.Boss_VItemSalesHeader1[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_584229 =
      stateVars.Boss_VItemSalesHeaderCollection ??
      this.state.Boss_VItemSalesHeaderCollection;

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_502087_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp640703Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp306482Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp502087Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_306482_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp640703Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp502087Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp306482Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_306482_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_306482_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_306482_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesHeaderPerson =
      result?.data.boss_VItemSalesHeaderPerson;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_306482_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_306482_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_605562 =
      stateVars.Boss_VItemSalesHeaderPerson ??
      this.state.Boss_VItemSalesHeaderPerson;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_908413_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp290500Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp580364Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp908413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_580364_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp290500Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp908413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp580364Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_580364_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_580364_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_580364_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesHeaderProcess =
      result?.data.boss_VItemSalesHeaderProcess;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_580364_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_580364_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_922724 =
      stateVars.Boss_VItemSalesHeaderProcess ??
      this.state.Boss_VItemSalesHeaderProcess;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_689993_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp387932Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp765016Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp689993Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_765016_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp387932Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp689993Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp765016Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_765016_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_765016_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_765016_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesHeaderWarehouse =
      result?.data.boss_VItemSalesHeaderWarehouse;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_765016_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_765016_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_977001 =
      stateVars.Boss_VItemSalesHeaderWarehouse ??
      this.state.Boss_VItemSalesHeaderWarehouse;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_354578_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp686767Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp481532Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp354578Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_481532_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp686767Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp354578Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp481532Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_481532_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_481532_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_481532_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesHeaderCollection =
      result?.data.boss_VItemSalesHeaderCollection;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_481532_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_481532_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_584229 =
      stateVars.Boss_VItemSalesHeaderCollection ??
      this.state.Boss_VItemSalesHeaderCollection;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_525060_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ParamByAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_525060_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_636739_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_525060_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_525060_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_525060_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_178454_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ParamByAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_525060_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_636739_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_178454_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_178454_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_178454_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunSatisAnalizComponent_530330_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ParamByAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunsatisanaliz_525060_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunSatisAnaliz/UrunSatisAnalizComponent_530330_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VItemSalesGrid = result?.data.boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunSatisAnalizComponent_530330_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunSatisAnalizComponent_530330_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "urunsatisanaliz_636739_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "urunsatisanaliz_525060_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "Key"
    );

    stateVars.dataSource_38920 =
      stateVars.Boss_VItemSalesGrid ?? this.state.Boss_VItemSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [526188] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.UrunSatisAnalizPageInit();
    }
  }
}
